import { api } from './client';

export interface AppNotification {
  id: string;
  title: string;
  body: string;
  type: string;
  read: boolean;
  createdAt: string;
}

export interface UnreadCountResponse {
  count: number;
}

export const notificationsApi = {
  /** GET /notifications */
  list: () => api.get<AppNotification[]>('/notifications'),

  /** GET /notifications/unread-count */
  unreadCount: () => api.get<UnreadCountResponse>('/notifications/unread-count'),

  /** POST /notifications/{id}/read */
  markRead: (id: string) => api.post<void>(`/notifications/${id}/read`),

  /** POST /notifications/read-all */
  markAllRead: () => api.post<void>('/notifications/read-all'),
};
